(() => {
  const pageTransition = document.querySelector('[data-page-transition]');
  const inThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
  const canUseStorage = (() => { try { return window.sessionStorage; } catch (_) { return null; } })();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const pageLabel = (pathname) => {
    if (pathname === '/') return 'HOME';
    const parts = pathname.split('/').filter(Boolean);
    return decodeURIComponent(parts[parts.length - 1] || 'VEDEORA').replace(/-/g, ' ').toUpperCase();
  };

  if (pageTransition && !inThemeEditor && !reduceMotion) {
    const label = pageTransition.querySelector('[data-page-transition-label]');
    const clearTransition = () => {
      pageTransition.classList.remove('is-covering', 'is-covered', 'is-revealing');
    };
    const cancelSavedTransition = () => {
      clearTransition();
      canUseStorage?.removeItem('vedeora-page-transition');
      canUseStorage?.removeItem('vedeora-page-transition-label');
    };

    /* A page restored by the browser Back button can be served from its page cache.
       Clear the old cover before that saved page becomes visible. */
    window.addEventListener('pagehide', clearTransition);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) cancelSavedTransition();
    });
    window.addEventListener('popstate', cancelSavedTransition);

    if (canUseStorage?.getItem('vedeora-page-transition') === 'true') {
      canUseStorage.removeItem('vedeora-page-transition');
      const savedLabel = canUseStorage.getItem('vedeora-page-transition-label');
      canUseStorage.removeItem('vedeora-page-transition-label');
      if (label && savedLabel) label.textContent = savedLabel;
      pageTransition.classList.add('is-covered');
      window.requestAnimationFrame(() => {
        window.setTimeout(() => {
          pageTransition.classList.remove('is-covered');
          pageTransition.classList.add('is-revealing');
          window.setTimeout(clearTransition, 380);
        }, 140);
      });
    }

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || pageTransition.classList.contains('is-covering')) return;
      const target = event.target;
      if (!(target instanceof Element)) return;

      const anchor = target.closest('a[href]');
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download') || anchor.hasAttribute('data-no-page-transition')) return;
      const href = anchor.getAttribute('href') || '';
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

      const destination = new URL(anchor.href, window.location.href);
      const current = new URL(window.location.href);
      if (destination.origin !== current.origin || destination.pathname === current.pathname) return;

      event.preventDefault();
      if (label) label.textContent = pageLabel(destination.pathname);
      pageTransition.classList.remove('is-revealing');
      pageTransition.classList.add('is-covering');
      canUseStorage?.setItem('vedeora-page-transition', 'true');
      canUseStorage?.setItem('vedeora-page-transition-label', pageLabel(destination.pathname));
      window.setTimeout(() => window.location.assign(destination.href), 320);
    }, true);
  }

  const intro = document.querySelector('[data-vedeora-intro]');
  if (intro) {
    const hideIntro = () => intro.classList.add('is-hidden');
    if (inThemeEditor || canUseStorage?.getItem('vedeora-intro-played') === 'true') {
      hideIntro();
    } else {
      window.setTimeout(() => {
        canUseStorage?.setItem('vedeora-intro-played', 'true');
        hideIntro();
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 300 : 2800);
    }
  }

  const siteHeader = document.querySelector('[data-site-header]');
  if (siteHeader) {
    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      const nextScrollY = window.scrollY;
      siteHeader.classList.toggle('is-hidden', nextScrollY > 100 && nextScrollY > lastScrollY + 8);
      lastScrollY = nextScrollY;
    }, { passive: true });
  }

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
    });
  }

  const productWrapper = document.querySelector('[data-product-form-wrapper]');
  const variantsNode = document.querySelector('[data-product-variants]');
  if (!productWrapper || !variantsNode) return;

  let variants = [];
  try { variants = JSON.parse(variantsNode.textContent || '[]'); } catch (_) { return; }
  const select = productWrapper.querySelector('[data-variant-select]');
  const price = productWrapper.querySelector('[data-product-price]');
  const submit = productWrapper.querySelector('[data-add-to-cart]');
  const label = productWrapper.querySelector('[data-add-label]');
  const inputs = [...productWrapper.querySelectorAll('[data-option-input]')];

  const money = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
    style: 'currency', currency: window.Vedeora?.currency || 'INR', maximumFractionDigits: 2,
  }).format(amount / 100);

  const updateVariant = () => {
    const choices = [...productWrapper.querySelectorAll('[data-product-option]')].map((group) => group.querySelector('[data-option-input]:checked')?.value);
    const variant = variants.find((item) => item.options?.every((option, index) => option === choices[index]));
    if (!variant || !select) return;
    select.value = variant.id;
    if (price) price.textContent = money(variant.price);
    if (submit) submit.disabled = !variant.available;
    if (label) label.textContent = variant.available ? 'Add to bag' : 'Sold out';
    inputs.forEach((input) => {
      const group = input.closest('[data-product-option]');
      const position = Number(group?.dataset.optionPosition) - 1;
      const selected = choices.slice(); selected[position] = input.value;
      const possible = variants.some((item) => item.available && item.options?.every((option, index) => option === selected[index]));
      input.disabled = !possible;
    });
    productWrapper.querySelectorAll('[data-selected-option]').forEach((node, index) => { node.textContent = choices[index] || ''; });
  };

  inputs.forEach((input) => input.addEventListener('change', updateVariant));
  updateVariant();
})();
